import { AssignmentType } from '@/api/types/sources';

export interface AssignmentTypeItem {
  name: string;
  value: AssignmentType;
  description: string;
}

export const assignmentTypeItems: AssignmentTypeItem[] = [
  {
    name: 'Direct',
    value: 'direct' as const,
    description: 'The permission is directly assigned to the source.',
  },
  {
    name: 'Inherited',
    value: 'inherited' as const,
    description: 'The permission is inherited.',
  },
];

export const assignmentTypeValues = ['direct', 'inherited'] satisfies [AssignmentType, ...AssignmentType[]];
export const assignmentTypeFilterValues = ['all', ...assignmentTypeValues] as const;
